import './App.css';
import React, { Suspense, useEffect } from 'react';
import { getFCMToken } from "./utils/getfcmtoken";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Loader from './components/Loader';
import { ToastContainer } from "react-toastify";
import { onMessage } from "firebase/messaging";
import { messaging } from "./config/firebase";   // path depends on your structure
import { showBrowserNotification } from './utils/notifications';

import { routesByRole } from "./config/routes";
import ProtectedRoute from "./auth/ProtectedRoute";
import RoleRouteGuard from "./routes/RoleRouteGuard";
import Login from './pages/auth/Login'; // ✅ make sure this import exists
import NotFound from "./pages/NotFound";
import ErrorBoundary from "./components/ErrorBoundary";

const AppRoutes = () => {

  const location = useLocation();
  // useEffect(() => {
  //   getFCMToken();
  // }, []);
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("📩 Foreground message:", payload);

      showBrowserNotification({
        title: payload.notification.title,
        body: payload.notification.body
      });
    });

    return () => unsubscribe();
  }, []);
  // ✅ MOVE HERE
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const allRoutes = Object.values(routesByRole).flat();

  return (
    <>

      {/* ✅ Loader outside layout */}
      {loading && <Loader />}

      <div className="App">
        <Routes location={location}>

          <Route
            path="/"
            element={
              localStorage.getItem("authToken")
                ? <Navigate to="/dashboard" replace />
                : <Navigate to="/login" replace />
            }
          />

          <Route
            path="/login"
            element={
              <Suspense fallback={<Loader />}>
                {localStorage.getItem("authToken")
                  ? <Navigate to="/dashboard" replace />
                  : <Login />}
              </Suspense>
            }
          />

          {allRoutes.map((route) => {
            const Component = route.component;

            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedRoute>
                    <RoleRouteGuard>
                      <Suspense fallback={<Loader />}>
                        <Component />
                      </Suspense>
                    </RoleRouteGuard>
                  </ProtectedRoute>
                }
              />
            );
          })}

          {/* ✅ 404 Route */}
          <Route path="*" element={<NotFound />} />

        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
        />
      </div>
    </>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <AppRoutes />
      </Router>
    </ErrorBoundary >
  );
};

export default App;